import React from 'react'
import BackIcon from 'assets/images/rectangle/right-green.svg'
import { useNavigate } from 'react-router-dom'
export default function Header({ title }: { title: string }) {
    const navigate = useNavigate()
    return (
        <div className=" w-full bg-transparent flex items-center justify-between px-4 h-14">
            <img
                src={BackIcon}
                alt="بازگشت"
                onClick={() => navigate(-1)}
                className=" w-6 h-6 cursor-pointer active:scale-90"
            />
            <p className=" text-green-1 text-lg font-bold">{title}</p>
            <span className="w-6" />
        </div>
    )
}
